import React, { useContext, useEffect, useState } from "react";

import { GlobalVariables } from "../../GlobalVariables";
import { usePermissions } from "../../utils/permissionsHook";
import { GlobalContext } from "../../contexts/GlobalContext";
import useSettingTranslate from "../../translations/settings/Setting";
import { GlobalSubheader } from "../../components/subHeader/GlobalSubheader";
import { DefaultPageContainer } from "../../components/layoutContainer/styles/LayoutContainer";
import { ButtonTogleStyle, DivStyle } from "../../components/modal/Modal";
import ReleaseVersion from "../../components/settings/ReleaseVersion";
import ChatSettings from "../chatSettings/ChatSettings";
import { CustomerEditData } from "../customerManagements/children/CustomerEditData";
import KnowledgeBase from "../KnowledgeBase/KnowledgeBase";
import { PermissionsAndUsers } from "../userAccess/components/PermissionsAndUsers";

export default function Settings({ location }) {
  const translate = useSettingTranslate();
  const { companyUser } = useContext(GlobalContext);

  const { checkIfUserHasPermission } = usePermissions();
  const [currentTab, setCurrentTab] = useState(1);

  const tabList = [
    {
      id: 1,
      name: translate.registrationData,
      permission: checkIfUserHasPermission(
        GlobalVariables.PERMISSIONS.SETTINGS_COMPANY
      ),
      forAccountant: false,
    },
    {
      id: 2,
      name: "Usuários e Permissões",
      permission: checkIfUserHasPermission(
        GlobalVariables.PERMISSIONS.SETTINGS_COMPANY
      ),
      forAccountant: false,
    },
    {
      id: 3,
      name: "Chat",
      permission: checkIfUserHasPermission(GlobalVariables.PERMISSIONS.CRM),
      forAccountant: true,
    },
    {
      id: 4,
      name: "Notas de Versão",
      permission: true,
      forAccountant: false,
    },
    {
      id: 5,
      name: "Integrações",
      permission: true,
      forAccountant: true,
    },
  ];

  const RecursiveTabs = ({ list }) => (
    <DivStyle style={{ marginBottom: "16px" }}>
      {list.map((item) => (
        <>
          {(item.forAccountant === false ||
            (companyUser?.isAccountant && item.forAccountant === true)) && (
            <>
              <ButtonTogleStyle
                key={item.id}
                active={currentTab === item.id}
                onClick={() => {
                  setCurrentTab(item.id);
                }}
                disabled={!item.permission}
              >
                <p style={{ textTransform: "none" }}>{item.name}</p>
              </ButtonTogleStyle>
              &nbsp;
            </>
          )}
        </>
      ))}
    </DivStyle>
  );

  useEffect(() => {
    if (
      !checkIfUserHasPermission(GlobalVariables.PERMISSIONS.SETTINGS_COMPANY)
    ) {
      setCurrentTab(4);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <GlobalSubheader
        title={"Configurações"}
        titleLocation={"/setting"}
      ></GlobalSubheader>
      <DefaultPageContainer>
        <div
          style={{
            background: "#fff",
            border: "1px solid #E0E0E0",
            borderRadius: 15,
            padding: 15,
          }}
        >
          <RecursiveTabs list={tabList} />

          {currentTab === 1 ? (
            <CustomerEditData
              pathname={location.pathname}
              customerId={companyUser?.companyId}
              from={"settings"}
              location={location}
            />
          ) : currentTab === 2 ? (
            <PermissionsAndUsers location={location} />
          ) : // <ConfigurePanel location={location} />
          currentTab === 3 ? (
            <ChatSettings />
          ) : currentTab === 4 ? (
            <ReleaseVersion />
          ) : (
            currentTab === 5 && <KnowledgeBase typeRender="tab" />
          )}
        </div>
      </DefaultPageContainer>
    </>
  );
}
